<div>
  <div #questionbody class="" *ngIf="!adminpaused && !proctorpaused" [attr.aria-label]="language.questionContent">
    <section id="" class="mobiletop p-0" style="width: 100%;" role="main">
      <div class="overlay" [ngClass]="{'show': isloadingdata}" role="alert" aria-live="assertive">
        <span class="sr-only">{{language.loadingQuestionWait}}</span>
      </div>

      <div class="col-md-12 mx-auto border-0 rounded-lg w-100">

        <div class="row pb-0 paddedrow">
          <div class="col-lg-12 d-flex flex-column">
            <div *ngIf="question.examQuestion.instructions" style="border: 1px #ccc solid; padding:2px">
              <p tabindex="0"><strong> {{language.instructions}}:</strong> {{question.examQuestion.instructions}}</p>
            </div>
            <div class="icon-box justify-content-center mx-3 pl-2 mb-2 h3" data-aos="fade-up" data-aos-delay="100">
              <section #questionhtmlsection class="lead main pt-0"
                style="font-size: 20px !important; color: #000; font-family: Poppins !important;" aria-live="polite"
                tabindex="0">
              </section>
            </div>
          </div>
        </div>
        <div class="row pb-0 paddedrow questionborder">
        </div>
        <div class="row pb-3 paddedrow" style="width: 100%;">
          <div class="col-lg-12 d-flex flex-column" *ngIf="!essayexam">
            <div class="section-title">
            </div>
            <div class="icon-box justify-content-center h3" data-aos="fade-up" data-aos-delay="100">
              <app-questionoptions style="font-family: Poppins !important;" *ngIf="this.question.examQuestionOptions"
                [options]="this.question.examQuestionOptions"
                [schedulequestionid]="question.examQuestion.schedulequestionid"
                [multiple]="question.examQuestion.hasMultipleAnswers" (radioselectedvalue)="OnRadioSelected($event)"
                (checkselectedvalue)="oncheckchanged($event)" [loadingSubject]="this.loadingSubject"
                [networkFailureSubject]="this.networkFailureSubject"></app-questionoptions>
            </div>
          </div>
          <app-saq-answer class="col-lg-12 d-flex flex-column" *ngIf="essayexam && issaq"
            (updatedanswer)="updatedanswer($event)" [question]="this.question" [issaq]="issaq"
            [examid]="this.question.examination.examid" [loadingSubject]="this.loadingSubject"
            [networkFailureSubject]="this.networkFailureSubject"
            [requiresScreenReader]="requiresScreenReader"></app-saq-answer>

          <app-essay class="col-lg-12 d-flex flex-column"
            *ngIf="essayexam && !issaq && !question.examQuestion.hasessaysubquestions"
            (updatedanswer)="updatedanswer($event)" [question]="this.question"
            [examid]="this.question.examination.examid" [loadingSubject]="this.loadingSubject"
            [networkFailureSubject]="this.networkFailureSubject"></app-essay>

        <!-- Essay Sub-Questions -->
       <app-essay-subquestions
          class="col-lg-12 d-flex flex-column"
          *ngIf="essayexam && !issaq && question.examQuestion.hasessaysubquestions"
          [question]="this.question"
          [examid]="this.question.examination.examid"
          [loadingSubject]="this.loadingSubject"
          [networkFailureSubject]="this.networkFailureSubject"
          (updatedanswer)="updatedanswer($event)">
        </app-essay-subquestions>

        </div>
        <div *ngIf="requiresScreenReader" class="row pb-3 paddedrow w-100"
          [attr.aria-label]="language.questionNavigation">
          <div class="d-flex justify-content-center align-items-center w-100 gap-5 py-2">
            <button *ngIf="question.questionCount != question.examQuestion.questionno"
              [attr.aria-disabled]="question.questionCount == question.examQuestion.questionno" type="button"
              class="btn cornblue btn-responsive" [attr.aria-label]="language.nextQuestion"
              (click)=" question.questionCount != question.examQuestion.questionno && nextbtnclicked()">
              <span class="btn-text">{{language.next}}</span>
              <i class="fa fa-long-arrow-right btn-icon-only" aria-hidden="true"></i>
            </button>
            <button
              *ngIf="!adminpaused && !proctorpaused && (question.questionCount == question.examQuestion.questionno)"
              type="button" (click)="finishclicked()" class="btn btn-danger btn-responsive">
              <span class="btn-text">{{language.finishAndSubmit}}</span>
            </button>

            <button [attr.aria-disabled]="question.examQuestion.questionno <= 1" type="button"
              class="btn cornblue btn-responsive" [attr.aria-label]="language.previousQuestion"
              (click)="question.examQuestion.questionno > 1 && prevbtnclicked()">
              <i class="fa fa-long-arrow-left btn-icon-only" aria-hidden="true"></i>
              <span class="btn-text">{{language.previous}}</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>